
import { eventBus, EVENTS } from './commons/EventBus.js';
import Utils from './commons/utils.js';
import API from "./commons/Api.js";
import {Paginator} from "./commons/paginator.js";




eventBus.on( EVENTS.PAGE_AFTER_RENDERING, function(data) {
    const template=data.template;
    if(data.refresh || (template!='podcast_categoria' && template != 'podcast')){
        return;
    }
    // chiudi player extended se aperto
    $(".close_player.extend_player").trigger("click");
    initInputData();
    initPaginatoreRubriche();
    initPaginatoreCatTuttiPazzi();
    initPaginatoreIlMeglioDI();
    initPaginatoreRDSMusica();
    if(data.slugToPlay){
        const slugToPlay=location.pathname;
        if($(`.podcast-play[data-slug='${slugToPlay}']`).length){
            $(`.podcast-play[data-slug='${slugToPlay}']`).click();
        }else{
            $(`#mostra_more_podcast`).click();
            let reclickidx=0;
            function reclick(){
                if($(`.podcast-play[data-slug='${slugToPlay}']`).length){
                    $(`.podcast-play[data-slug='${slugToPlay}']`).click();
                }else{
                    if(reclickidx>=5){
                        return;
                    }
                    setTimeout(()=>{
                        reclick();
                    },500);
                }
            
            }
            reclick();
        }
        
    }



});

$(document).ready(function () {
    initInputData();
    initPaginatoreRubriche();
    initPaginatoreCatTuttiPazzi();
    initPaginatoreIlMeglioDI();
    initPaginatoreRDSMusica();
    $(document).on('click','#toggle_filter', (e)=>{
        $(".filter_container").slideToggle();

    });
});

function initInputData(){

    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    today = dd + '/' + mm + '/' + yyyy;
    $('input[name="daterange"]').daterangepicker({
        opens: 'center',
        maxDate: today,
        autoUpdateInput: false,
        "locale": Utils.SETTINGS.DATERANGEPICKER
    }, function(start, end, label) {
        console.log("A new date selection was made: " + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD'));
    });


    $('input[name="daterange"]').on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('DD/MM/YYYY') + ' - ' + picker.endDate.format('DD/MM/YYYY'));
        $(this).attr("data-start",picker.startDate.format('YYYY-MM-DD'));
        $(this).attr("data-end",picker.endDate.format('YYYY-MM-DD'));
        filterPodcast();
    });

    $('input[name="daterange"]').on('cancel.daterangepicker', function(ev, picker) {
        $(this).val('gg/mm/aa - gg/mm/aa');
        $(this).attr("data-start","");
        $(this).attr("data-end","");
        filterPodcast();
    });

}

$(document).on('click','.filter_option', function(){
    $(".filter_option").removeClass("filter_selected");
    $(this).addClass("filter_selected");
    $("#filter_order_selected").text($(this).text());
    filterPodcast();
});

function filterPodcast(){

    $("#mostra_more_podcast").attr("data-start", 0);
    var filter = $(".filter_selected").attr("data-value");
    var order = filter == "more" ? "DESC" : "ASC";
    var slug = $("#filtro_episodi_podcast").attr("data-slug");
    var start_date = $("input[name=\"daterange\"]").attr("data-start");
    var end_date = $("input[name=\"daterange\"]").attr("data-end");
    var search = $("#cerca_podcast_text").val();
    getPodcast(slug, end_date, start_date, order, search);
}

function getPodcast(slug, end_date, start_date, order, search){

    var container = "#podcast_categoria-podcast_single_item";
    var template_podcast = window.templates["podcast_single_item"];
    var media_to_replace = '"{{img_src}}", podcast[i].img_src';
    if(slug == "100-secondi-di-sport"){
        container = "#podcast_categoria-podcast_video_single_item";
        template_podcast = window.templates["podcast_video_single_item"];
        media_to_replace = '"{{video_dam}}", podcast[i].video_dam';
    }


    if(end_date == undefined || end_date == ""){
        var today = new Date();
        today.setDate(today.getDate() + 1);
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        today = yyyy + '-' + mm + '-' + dd;

        end_date = today;
    }
    var paginatore = $("#mostra_more_podcast").attr("data-start");
    API.get("site/getPodcastFiltered", { slug: slug, end_date: end_date, start_date: start_date, order: order, start_limit:paginatore, limit: 6, search: search}, function (resp) {

        var podcast = resp.data;
        if(paginatore == 0){
            $(container).empty();
        }
        if(podcast.length > 0){

            $("#no_result_mex").hide();
            for (let i = 0; i < podcast.length; i++) {
                let template = template_podcast;

                template = template.replaceAll("{{audio_src}}", podcast[i].audio_src)
                    .replaceAll("{{post_title}}", podcast[i].post_title)
                    .replaceAll("{{page_title}}", podcast[i].page_title)
                    .replaceAll("{{post_date}}", podcast[i].post_date)
                    .replaceAll("{{post_slug}}", podcast[i].post_slug)
                    .replaceAll("{{slug}}", podcast[i].slug)
                    .replaceAll("{{hidden_class}}", podcast[i].hidden_class)
                    .replaceAll("{{ID}}", podcast[i].ID) ;

                if(podcast[i].video_dam){
                    template = template.replaceAll("{{video_dam}}", podcast[i].video_dam)
                    .replaceAll("{{category_name}}", podcast[i].category_name)
                    .replaceAll("{{video_aws_output}}", podcast[i].video_aws_output)
                } else if(podcast[i].img_src){
                    template = template.replaceAll("{{img_src}}", podcast[i].img_src)
                }

                $(container).append(template);
            }
            if(podcast.length < 6){
                $(".mostra_altri_podcast_parent").hide();
            } else{
                $(".mostra_altri_podcast_parent").show();
            }
        } else{
            $(".mostra_altri_podcast_parent").hide();
            $("#no_result_mex").show();
        }
    });
}

$(document).on('click','#mostra_more_podcast', (e)=>{
    var filter = $(".filter_selected").attr("data-value");
    var order = filter == "more" ? "DESC" : "ASC";
    var slug = $("#filtro_episodi_podcast").attr("data-slug");
    var start_date = $("input[name=\"daterange\"]").attr("data-start");
    var end_date = $("input[name=\"daterange\"]").attr("data-end");
    let start_paginatore = parseInt($("#mostra_more_podcast").attr("data-start")) + 6;
    var search = $("#cerca_podcast_text").val();
    $("#mostra_more_podcast").attr("data-start", start_paginatore);
    getPodcast(slug, end_date, start_date, order, search);
});

$(document).on('keyup','#cerca_podcast_text', function(){
   var search_value = $("#cerca_podcast_text").val();
   if(search_value.length > 3){
      var filter = $(".filter_selected").attr("data-value");
      var order = filter == "more" ? "DESC" : "ASC";
      var slug = $("#filtro_episodi_podcast").attr("data-slug");
      var start_date = $("input[name=\"daterange\"]").attr("data-start");
      var end_date = $("input[name=\"daterange\"]").attr("data-end");
     if(search_value.length >= 3 || search_value == 0){
         getPodcast(slug, end_date, start_date, order, search_value);
     }
   }
});

function initPaginatoreRubriche(){

    const breakpoints_rubriche = [
        { maxWidth: 550, perPage: 2 },
        { maxWidth: 650, perPage: 2 },
        { maxWidth: 1150, perPage: 4 },
        { perPage: 6 }
    ];

    ///usate stesse classi dei blocchi classifiche in home
    new Paginator($('#paginatore_rubriche'), {
        total: 8 ,
        breakpoints: breakpoints_rubriche,
        cssVar: '--pod_rub_paginator',
        swipeElementSelector: '#podcast-single_blocco_podcast_audio'
    });
}
//
function initPaginatoreCatTuttiPazzi(){

    const breakpoints_tutti_p= [
        { maxWidth: 550, perPage: 2 },
        { maxWidth: 650, perPage: 2 },
        { maxWidth: 1150, perPage: 4 },
        { perPage: 6 }
    ];

    ///usate stesse classi dei blocchi classifiche in home
    new Paginator($('#paginatore_cat_tutti_pazzi'), {
        total: 7 ,
        breakpoints: breakpoints_tutti_p,
        cssVar: '--pod_tutti_p_paginator',
        swipeElementSelector: '#podcast-podcast_tutti_pazzi_list'
    });
}


function initPaginatoreIlMeglioDI(){

    const breakpoints_meglio= [
        { maxWidth: 550, perPage: 2 },
        { maxWidth: 750, perPage: 3 },
        { maxWidth: 1150, perPage: 4 },
        { perPage: 4 }
    ];

    ///usate stesse classi dei blocchi classifiche in home
    new Paginator($('#paginatore_il_meglio_di'), {
        total: 4 ,
        breakpoints: breakpoints_meglio,
        cssVar: '--pod_meglio_paginator',
        swipeElementSelector: '#podcast-podcast_il_meglio_rds_list'
    });
}


function initPaginatoreRDSMusica(){

    const breakpoints_musica= [
        { maxWidth: 1100, perPage: 1 },
        { perPage: 2 }
    ];

    ///usate stesse classi dei blocchi classifiche in home
    new Paginator($('#paginatore_rds_musica'), {
        total: 2 ,
        breakpoints: breakpoints_musica,
        cssVar: '--pod_musica_paginator',
        swipeElementSelector: '#podcast-single_blocco_podcast_musica'
    });
}
